function sortParser(sortBy) {
  if (!sortBy) return null;
  const { id, desc } = sortBy;
  return desc ? `-${id}` : id;
}
export default sortParser;
